import { combineReducers } from 'redux'

import list from './list/slice'

const appliedReducer = combineReducers({
  list,
})

export default appliedReducer
